import { render, staticRenderFns } from "./ArticleInfo.vue?vue&type=template&id=0c6a0b5c&scoped=true"
import script from "./ArticleInfo.vue?vue&type=script&lang=js"
export * from "./ArticleInfo.vue?vue&type=script&lang=js"
import style0 from "./ArticleInfo.vue?vue&type=style&index=0&id=0c6a0b5c&prod&lang=less&scoped=true"
import style1 from "./ArticleInfo.vue?vue&type=style&index=1&id=0c6a0b5c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6a0b5c",
  null
  
)

export default component.exports